import { generateConfig } from "../../../utilityFunctions";
import axios from 'axios'
import { LOGIN_USER } from "../actionTypes/types";
import React, { Dispatch } from "react";
import {GlobalError} from "../../../components/errors/GlobalError";

//This is a sub-action for LoginWithGoogle, LoginWithDiscord and LoginWithToken dispatch actions. 
//It receives it's dispatch action as a prop instead of from useAppDispatch as it is not actually a dispatch function.

export const LoginWithApp = async (
  accessToken: string, 
  refreshToken: string, 
  persistentLogin: boolean, 
  dispatch: Dispatch<any>, 
  setRedirect: React.Dispatch<React.SetStateAction<boolean>>) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const config = generateConfig(accessToken);

    try {
      const userInfoResponse = await axios.get(`${BASE_URL}/api/users/info`, config);
      console.log("this is userInfoResponse", userInfoResponse)
      if (userInfoResponse.status === 200) {
        sessionStorage.removeItem("demoAddress");
        const payloadObject = {
          accessToken: accessToken,
          refreshToken: refreshToken,
          userInfo: userInfoResponse.data
        }
        dispatch({type: LOGIN_USER, payload: payloadObject});
        if (persistentLogin) {
          window.localStorage.setItem("user", JSON.stringify(payloadObject));
        } else {
          window.sessionStorage.setItem("user", JSON.stringify(payloadObject));
        }
       return setRedirect(true);
      }
    } catch(error) {
      console.log("there has been an error for userInfoResponse", error)
      GlobalError(error);
    }
}